// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"7f14e5f1","245":"b802062c"}[chunkId] + ".chunk.js";
};